import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import HeaderDropdown from '../../containers/HeaderDropdown';
import RangeFilter from '../containers/RangeFilter';
import SimpleHeader from '../../../headers/simpleHeader';
import List from '../containers/List';


const MarketingLeads = ({ baseUrl }) => (
  <div>
    <SimpleHeader heading="Client Acquisition Channels">
      <HeaderDropdown title="Client Acquisition Channels" />
    </SimpleHeader>

    <div className="c-wrapper s-v2">
      <div className="u-max-width-710 u-margin-auto u-mv-">
        <RangeFilter />

        <div className="u-mt">
          <List />
        </div>

        <div className="u-text-center u-mt">
          <Link
            className="c-link-button u-type--semibold"
            to={`${baseUrl}/add`}
          >
            + Add channel
          </Link>
        </div>

      </div>
    </div>

  </div>
);
MarketingLeads.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  isBrandShop: PropTypes.bool.isRequired,
};

export default MarketingLeads;
